import { useReadAloud as useQCLReadAloud } from '@3plearning/question-components-library';
import { useState, useEffect } from 'react';
import Resources from '../../../helpers/resources';
import { getValueFromUrl } from '../../../helpers/utils';

export const useReadAloud = () => {
  const [readAloudConfig, setReadAloudConfig] = useState({
    gatewayUrl: window._env_.ReadAloudGatewayUrl,
    token: Resources.env.authToken,
    locale: 'en-AU'
  });

  const onLocaleChange = (locale) => {
    setReadAloudConfig({
      ...readAloudConfig,
      locale
    });
  };

  const { setTranscriptModalInitialPosition, setReadAloudConfig: setQCLReadAloudConfig } = useQCLReadAloud();

  useEffect(() => {
    setTranscriptModalInitialPosition({
      left: Math.max(window.innerWidth - 520, 0),
      top: 75
    });
    const localeFromUrl = getValueFromUrl('locale') || 'en-AU';
    const locale = /es-/ig.test(localeFromUrl) ? 'es-US' : localeFromUrl;

    setReadAloudConfig(prevConfig => ({
      ...prevConfig,
      locale
    }));

    setQCLReadAloudConfig(prevConfig => ({
      ...prevConfig,
      locale
    }));
  }, []);

  return { readAloudConfig, onLocaleChange };
};
